import { useEffect } from "react";
import { useApiClient } from "../api/ApiClientContext";
import { setServicePaused } from "../paused";

const POLL_MS = 60_000;

export const PAUSED_COPY = {
  title: "Atlas is paused",
  body:
    "We've hit a safety limit on our side and switched the service off while we check it. " +
    "Nothing you've saved is lost. We'll have it back as soon as we've had a look. " +
    "If you need something urgently, sing out to Luke.",
};

/** Full-page notice (spec §7.2). Unmounting the page behind it is what stops
 *  tile and media fetching in an open tab; this component just waits. */
export function PausedScreen(): JSX.Element {
  const client = useApiClient();
  useEffect(() => {
    const check = (): void => {
      void client
        .getStatus()
        .then((s) => {
          if (!s.paused) setServicePaused(false);
        })
        .catch(() => undefined);
    };
    // Once on mount: the pause may already have been lifted by the time this
    // screen appears, and a minute of it for nothing reads as broken.
    check();
    const id = window.setInterval(check, POLL_MS);
    return () => window.clearInterval(id);
  }, [client]);
  return (
    <main role="status" style={{ maxWidth: 560, margin: "15vh auto", padding: "0 1rem" }}>
      <h1>{PAUSED_COPY.title}</h1>
      <p>{PAUSED_COPY.body}</p>
    </main>
  );
}
